import React from 'react';
import { TabStatus } from '../../types/index.js';

/** Shows the marketplace moderation state of the user's own tab (PENDING / REJECTED only). */
export const ModerationBadge: React.FC<{ status?: TabStatus; tabId: string }> = ({
  status,
  tabId
}) => {
  if (status !== 'PENDING' && status !== 'REJECTED') return null;
  const pending = status === 'PENDING';
  return (
    <span
      data-testid={`tab-status-${tabId}`}
      className={`h-6 px-2.5 rounded-full text-xs inline-flex items-center shrink-0 whitespace-nowrap select-none border ${
        pending
          ? 'bg-warning/15 border-warning/30 text-warning-soft'
          : 'bg-error/15 border-error/30 text-error-soft'
      }`}
    >
      {pending ? 'در انتظار تأیید' : 'رد شده'}
    </span>
  );
};
